import React, { useState } from 'react'
import * as routeLink from "../../constants/routeLink";

import CardShopDog from "../../components/CardShopDog/index";
import ProcessBar from "../../components/ProcessBar/index";

import { useNavigate } from 'react-router-dom';
const Spin = (props) => {

  const navigate = useNavigate();
  const onclickChangePage = (path) => {
    navigate(path);
  }

  const  [dataShop, setdataShop] = useState([
    { title: "Pupy Doge", price: "50,000",orderNumber:1},
    { title: "Pupy Doge", price: "50,000",orderNumber:2},
    { title: "Pupy Doge", price: "50,000",orderNumber:3},
    { title: "Pupy Doge", price: "50,000",orderNumber:4},
    { title: "Pupy Doge", price: "50,000",orderNumber:5},
    { title: "Pupy Doge", price: "50,000",orderNumber:6},
    { title: "Pupy Doge", price: "50,000",orderNumber:7},
    { title: "Pupy Doge", price: "50,000",orderNumber:8},
    { title: "Pupy Doge", price: "50,000",orderNumber:9},
    { title: "Pupy Doge", price: "50,000",orderNumber:10},
  ]);
  return (
    <div className='d-flex justify-content-center align-items-center flex-column'>


      <div className='w-100 d-flex justify-content-center align-items-center flex-column p-2'>

        <div className='d-flex w-100 flex-column justify-content-center align-items-center'>
          <h4 className='w-100 text-white justify-content-center align-items-center fs-extra d-flex m-0 mx-2'>Furry Doge</h4>
          <div className='w-100 d-flex justify-content-center align-items-center mt-2 mb-2'>
            <div className='w-50 d-flex justify-content-end align-items-center '>
              <span className='text-white me-2  fw-bold'> 10,298</span>
              <div className='card-icon bg-white radius-custom-4' style={{ width: "20px", height: "20px" }}>
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
              <span className='text-white mx-2 fw-bold'> /</span>
            </div>
           
            <div className='w-50 d-flex justify-content-start align-items-center '>
              <span className='text-white me-2 fw-bold'> 10,298</span>
              <div className='card-icon bg-white radius-custom-4' style={{ width: "20px", height: "20px" }}>
                <img className='w-100 h-100' src={`${routeLink.domain}/assets/imgs/footprintDog.png`} />
              </div>
            </div>
          </div>

            <ProcessBar/>
        </div>
      </div>

      <div className='w-100 d-flex justify-content-center align-items-start flex-column p-2'>
          {dataShop && dataShop.map((value, index) => {
       
        return  <CardShopDog item={value} actions={() => onclickChangePage(routeLink.DAILY_REWARD)} />
          })}

      </div>
     
    </div>
  )
}

export default Spin;
